document.querySelectorAll('.yoria-blog').forEach((section) => {
  if (section.dataset.manualVideoReady === 'true') return;

  const dialog = section.querySelector('[data-manual-video-dialog]');
  const player = section.querySelector('[data-manual-video-player]');
  const title = section.querySelector('[data-manual-video-title]');
  const closeButton = section.querySelector('[data-manual-video-close]');

  if (!dialog || !player || !title || !closeButton) return;

  const closeVideo = () => {
    player.pause();
    player.removeAttribute('src');
    player.load();
    if (dialog.open) dialog.close();
  };

  section.querySelectorAll('[data-manual-video-open]').forEach((button) => {
    button.addEventListener('click', () => {
      player.src = button.dataset.videoSrc;
      title.textContent = button.dataset.videoTitle;
      dialog.showModal();
    });
  });

  closeButton.addEventListener('click', closeVideo);
  dialog.addEventListener('close', () => {
    player.pause();
    player.removeAttribute('src');
    player.load();
  });
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closeVideo();
  });

  section.dataset.manualVideoReady = 'true';
});
